<template>
    <div id="help">
        <my-header></my-header>
        <div class="main-container tableWrap">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="文档">
                    <template slot-scope="scope">
                        <a class="words" title="点击下载" :href="scope.row.filePath" target="_blank" :download="scope.row.fileName">
                           {{ scope.row.fileName}}
                        </a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import MyHeader from '../common/Header.vue'
    export default {
        name: 'help',
        data() {
            return {
                tableData: []
            }
        },
        components: {
            MyHeader
        },
        created(){
            var path = this.$route.name;
            if(path == 'help'){
                this.$root.activeIndex = 'setting';
            }
        },
        mounted(){
            this.tableData = [{
                fileName: '注册操作手册V1.0.pdf',
                filePath: '../../static/documents/注册操作手册V1.0.pdf'
            },{
                fileName: '投标操作手册V1.0.pdf',
                filePath: '../../static/documents/投标操作手册V1.0.pdf'
            }]
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";
    #help {
        position: relative;
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .tableWrap {
           padding-top: 80px;
        }
        & .detail {
            margin-top: 30px;
            p {
                text-align: right;
            }
           .el-button {
               padding: 8px 22px;
            }
        }
        & .title {
            text-align: left;
            & img {
                width: 240px;
                height: 29px;
                margin-right: 20px;
                vertical-align: text-bottom;
                cursor: pointer;
            }
        }
        & table thead th {
            text-align: center;
        }
        & .words {
            color: #333;
            text-decoration: none;
        }
        & .words:hover {
            color: $--primary-color;
            text-decoration: underline;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Help.vue